import { thematicsAPI } from '@/api'

export const fetchCatalogFolders = async (): Promise<IFolder[]> => {
  try {
    const res = await thematicsAPI.getAllNotEmpty({
      params: {
        'filter[view][eq]': 1,
      },
    })
    return res?.data?.data ?? []
  } catch (error) {
    console.error('Ошибка загрузки папок:', error)
    return []
  }
}

export const fetchSubFolders = async (): Promise<ISubFolder[]> => {
  try {
    const res = await thematicsAPI.getAllSubFoldersNotEmpty()
    return res?.data?.data ?? []
  } catch (error) {
    console.error('Ошибка загрузки папок:', error)
    return []
  }
}
